import { useMutation } from "@tanstack/react-query"
import notesService from "services/notes.service"
import type { TCreateNoteRequest, TUpdateNoteRequest } from "types/elevationReferences.type"

export const useCreateNote = () => {
	return useMutation({
		mutationKey: ["createNote"],
		mutationFn: ({ quotationId, body }: { quotationId: number; body: TCreateNoteRequest }) =>
			notesService.createNote(quotationId, body),
	})
}

export const useUpdateNote = () => {
	return useMutation({
		mutationKey: ["updateNote"],
		mutationFn: ({ quotationId, noteId, body }: { quotationId: number; noteId: number; body: TUpdateNoteRequest }) =>
			notesService.updateNote(quotationId, noteId, body),
	})
}

export const useDeleteNote = () => {
	return useMutation({
		mutationKey: ["deleteNote"],
		mutationFn: ({ quotationId, noteId, version }: { quotationId: number; noteId: number; version: number }) =>
			notesService.deleteNote(quotationId, noteId, version),
	})
}
